import styled from "styled-components";

const rowSpacing = 12;
const borderSize = 2;
const borderColor = "#ccc";

export const Table = styled.table`
  width: 100%;
  font-size: 12px;

  font-family: Arial;
  margin: 2px 0;
`;

export const THead = styled.thead`
  height: 30px;
`;

export const HeaderRow = styled.tr`
  th:first-child {
    border-left: none;
    border-right: none;
  }

  th:last-child {
    border-left: none;
    border-right: none;
    white-space: nowrap;
  }

  th:before {
    content: "";
    position: absolute;
    width: 2px;
    height: 70%;
    background: ${borderColor};
    right: 0;
    top: 15%;
  }

  th:last-child:before {
    display: none;
  }
`;

export const Header = styled.th`
  text-align: ${({ textAlign }) => textAlign ?? "left"};
  background-color: #e8e8e8;
  padding: 0 20px;
  width: ${({ width }) => (width !== undefined ? width : "auto")};
  position: relative;
  cursor: ${({ clickable }) => (clickable ? "pointer" : "default")};
  white-space: nowrap;
`;

export const OrderIconWrapper = styled.span`
  height: 14px;
  width: 14px;
  font-size: 14px;
  margin-left: 5px;
`;

export const TBody = styled.tbody``;

export const Row = styled.tr`
  border: 0;

  td {
    position: relative;
    height: 60px;
  }

  td:before {
    content: "";
    position: absolute;
    width: 1px;
    height: calc(70% - ${rowSpacing}px);
    background: ${borderColor};
    right: 0;
    top: calc(15% + ${rowSpacing / 2}px);
  }

  td:last-child:before {
    display: none;
  }

  td:first-child > div {
    padding-left: 10;
  }

  td:last-child > div {
    padding-right: 0;
    overflow: hidden;
  }

  td .nowrap {
    white-space: nowrap;
  }
`;

export const Column = styled.td`
  height: inherit;
  width: ${({ width }) => (width !== undefined ? width : "auto")};
`;

export const ColumnContentWrapper = styled.div`
  width: 100%;
  height: calc(100% - ${rowSpacing / 2}px);
  margin-top: 0px;
  border-bottom: ${borderSize}px solid ${borderColor};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 5px;
`;

export const FlexWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: ${({ direction }) => direction ?? "row"};
  justify-content: ${({ justify }) => justify ?? "center"};
  align-items: ${({ align }) => align ?? "center"};
  color: ${({ color }) => color ?? "black"};
  font-weight: ${({ fontWeight }) => fontWeight ?? "normal"};

  :nth-child(2) {
    margin-top: 2px;
  }
`;
